package org.mkui.font

enum class Weight {
    NORMAL, BOLD
}